var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('sitenav'),_c('div',{staticClass:"layout__right"},[_c('siteheader'),_c('transition',{attrs:{"mode":"out-in","name":"slide-fade"}},[_c('router-view')],1),_c('sitefooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }